export default "__VITE_ASSET__Cn7H8XN2__"